import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "position-relative font-size-12-400 font-grey d-flex align-center card-container justify-space-between" }




export default /*@__PURE__*/_defineComponent({
  __name: 'FlexContainer',
  props: {
  title: String
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(__props.title), 1),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})